import { useSyncExternalStore } from "react";
import { getCookies } from "@/common/browser/state";

/// Default cookie name used by CookieConsent.
export const COOKIE_CONSENT_NAME = "cc_cookie";

/// Category the user must accept for analytics.
const CONSENT_STATISTICS = "statistics";

/// https://cookieconsent.orestbida.com/advanced/callbacks-events.html
const CONSENT_EVENTS = ["cc:onConsent", "cc:onChange"] as const;

export type ConsentStatus = "pending" | "granted" | "denied";

export function parseStatisticsConsent(raw: string | undefined): ConsentStatus {
  if (!raw) return "pending";

  try {
    const { categories } = JSON.parse(decodeURIComponent(raw)) as {
      categories?: unknown;
    };
    if (!Array.isArray(categories)) return "pending";
    return categories.includes(CONSENT_STATISTICS) ? "granted" : "denied";
  } catch {
    return "pending";
  }
}

export function readStatisticsConsent(): ConsentStatus {
  const raw = getCookies()[COOKIE_CONSENT_NAME];
  return parseStatisticsConsent(raw);
}

function subscribe(onStoreChange: () => void): () => void {
  for (const event of CONSENT_EVENTS) {
    window.addEventListener(event, onStoreChange);
  }
  return () => {
    for (const event of CONSENT_EVENTS) {
      window.removeEventListener(event, onStoreChange);
    }
  };
}

export function useStatisticsConsent(): ConsentStatus {
  return useSyncExternalStore(
    subscribe,
    readStatisticsConsent,
    () => "pending",
  );
}
